// extracted by mini-css-extract-plugin
module.exports = {"tip":"styles_tip__Fs0WD","questionBankBttn":"styles_questionBankBttn__1glLm","header":"styles_header__2piMg","questionBankModal":"styles_questionBankModal__irI7f"};